








import { Component, Vue } from "vue-property-decorator";
import { Company, getOurCompanies } from "@/api/company-api";

import CompanyList from "@/templates/CompanyList.vue";
import GroupFilter from "@/entities/group-filter";

@Component({
  components: {
    CompanyList
  }
})
export default class OfficeListPage extends Vue {
  get companies() {
    return this.rawCompanies.filter(c => this.searchFilter.isSatisfied(c));
  }

  select({ id }: { id: number }) {
    const params = { id: String(id) };
    this.$router.push({ name: "office-show", params });
  }

  create() {
    this.$router.push({ name: "office-new" });
  }

  search(query: string) {
    this.query = query;
  }

  private rawCompanies: Company[] = [];
  private query = "";

  private get searchFilter() {
    return new GroupFilter({
      query: this.query,
      role: "all"
    });
  }

  private created() {
    this.initCompanies();
  }

  private async initCompanies() {
    this.rawCompanies = await getOurCompanies();
  }
}
